import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { Modal, notification, Icon, Button, Tooltip, DatePicker } from "antd";
import { Calendar, momentLocalizer } from "react-big-calendar";
import axios from "axios";
import moment from "moment";

import { IoLayers } from "react-icons/io5";

import { GlobalContext } from "../../app/providers/GlobalState";

import DrawerAdicionarAula from "./Drawers/DrawerAdicionarAula";
import ModalLoading from "../../shared/components/Modals/ModalLoading";
import ModalViewer from "../../shared/components/Modals/ModalViewer";
import Acessos from "../../Geral/Acessos/Acessos";
import Legenda from "./Componentes/Legenda";

import ModalCriacaoLoteAulas from "./Componentes/modals/ModalCriacaoLoteAulas";
import ModalProcessarAulas from "./Componentes/modals/ModalProcessarAulas";

import "react-big-calendar/lib/css/react-big-calendar.css";

const localizer = momentLocalizer(moment);

const { MonthPicker, WeekPicker } = DatePicker;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};
const blockedRules = {
    0: null, // Domingo — tudo bloqueado
    1: { start: 6, end: 23 }, // Segunda
    2: { start: 6, end: 23 }, // Terça
    3: { start: 6, end: 23 }, // Quarta
    4: { start: 6, end: 23 }, // Quinta
    5: { start: 6, end: 23 }, // Sexta
    6: { start: 6, end: 23 } // Sábado
};
class Main extends Component {
    static contextType = GlobalContext;

    state = {
        dataCalendario: new Date(),
        vista: window.innerWidth <= 768 ? "day" : "week",
        dataInicialMes: moment().startOf("month").format("YYYY/MM/DD"),
        inicio: moment().startOf("week").format("YYYY/MM/DD"),
        termino: moment().endOf("week").format("YYYY/MM/DD"),
        horaInicioCalendario: undefined,
        dataHoraInicio: "",
        periodos: "",
        periodosTooltip: "",
        monthPickerOpen: false,
        aulas: [],
        ultimaCor: "",
        isNota: false,
        isEJAoF: false,
        tituloVivencia: false,
        fases: [],
        mostrarParecerPorAula: false,
        //LOADING
        iconLoading: false,
        //DRAWER ADICIONAR
        visible: false,
        //MODAL DETALHE
        modalEventoVisible: false,
        aulaId: "",
        titulo: "",
        mesmoDia: false,
        data: "",
        horas: "",
        descricao: "",
        autor: false,
        cursoId: "",
        moduloIndex: "",
        tarefaId: "",
        stepmeet: "",
        tipo: "",
        link: "",
        botaoAtivo: false,
        registarUrl: "",
        aluno: false,
        tipoBotao: {},
        externa: false,
        convite: "",
        //FILTRO
        filtroEscolaId: null,
        //REDIRECT
        redirect: false,
        redirectLink: "",
        //MODAL BROWSERS INFO
        visibleBrowsers: false,
        tituloCarousel: "Informação sobre como deve sair da Stepmeet",
        meetID: 0,
        mensagemId: 1,
        visivelMensagem1: false,
        visivelMensagem2: false,
        naoMostrarMensagem: false,
        empresaId: localStorage.getItem("entidade_id"),
        //DOCS
        docs: [],
        visibleLoading: false,
        modalVisible: false,
        //MODAL CRIAÇÃO LOTE AULAS
        processoId: null,
        visibleModalCriacaoLoteAulas: false,
        listaDisciplinas: [],
        //MODAL PROCESSAR LOTE AULAS
        visibleModalProcessarAulas: false
    };

    UNSAFE_componentWillMount() {
        this.mostrarPareceres();

        if (
            localStorage.getItem("posicao_calendario") &&
            localStorage.getItem("temp_codigo_curso") === localStorage.getItem("codigo_curso")
        ) {
            const data = new Date(localStorage.getItem("posicao_calendario"));
            let vista = localStorage.getItem("vista_calendario");

            if (vista === null) {
                localStorage.setItem("vista_calendario", "week");
                vista = "week";
            }

            this.setState(
                {
                    dataCalendario: data,
                    vista,
                    inicio: moment(data).startOf(vista).isoWeekday(0).format("YYYY/MM/DD"),
                    termino: moment(data).endOf(vista).isoWeekday(6).format("YYYY/MM/DD")
                },
                () => this.listar()
            );
        } else {
            localStorage.setItem("posicao_calendario", this.state.dataCalendario);
            localStorage.setItem("vista_calendario", this.state.vista);
            localStorage.setItem("temp_codigo_curso", localStorage.getItem("codigo_curso"));
            this.listar();
        }

        this.periodoBimestre();
        this.listarFasesEscolares();
        this.listaDiarioEscolaridade();
        this.carregarListaDisciplinas();
    }

    componentDidUpdate() {
        const { estabelecimento } = this.props;
        const { filtroEscolaId } = this.state;

        if (estabelecimento?.id && estabelecimento.id !== filtroEscolaId) {
            this.setState({
                filtroEscolaId: estabelecimento.id
            });
        }
    }

    atualizarPosicaoCalendário = dataCalendario => {
        localStorage.setItem("posicao_calendario", dataCalendario);
        const vista = localStorage.getItem("vista_calendario");
        this.setState(
            {
                dataCalendario,
                vista,
                inicio: moment(dataCalendario).startOf(vista).format("YYYY/MM/DD"),
                termino: moment(dataCalendario).endOf(vista).format("YYYY/MM/DD")
            },
            () => this.listar()
        );
        this.periodoBimestre();
        this.listarFasesEscolares();
        this.listaDiarioEscolaridade();
    };

    handleSelectSlot = slotInfo => {
        const start = slotInfo.start;

        const rule = blockedRules[start.getDay()];
        const hour = start.getHours();

        if (!rule || hour < rule.start || hour >= rule.end) {
            return;
        }

        if (this.state.vista === "month") return;
        this.setState({
            dataHoraInicio: start,
            visible: true
        });
    };

    openMonthPicker = () => {
        this.setState({ monthPickerOpen: true });
    };

    closeMonthPicker = () => {
        this.setState({ monthPickerOpen: false });
    };

    handleMonthChange = value => {
        if (!value) {
            this.closeMonthPicker();
            return;
        }

        moment.updateLocale("pt", { week: { dow: 0 } });

        const date = value.clone();

        let inicio;
        let termino;

        if (this.state.vista === "month") {
            inicio = date.clone().startOf("month").startOf("week");
            termino = date.clone().endOf("month").endOf("week");
        } else {
            inicio = date.clone().startOf("week");
            termino = date.clone().endOf("week");
        }

        const dataCalendario = date.toDate();

        this.setState(
            {
                dataCalendario,
                inicio: inicio.format("YYYY/MM/DD"),
                termino: termino.format("YYYY/MM/DD"),
                monthPickerOpen: false
            },
            () => {
                this.listar();
                this.periodoBimestre();
                localStorage.setItem("posicao_calendario", dataCalendario);
            }
        );
    };

    periodoBimestre = () => {
        this.setState(
            {
                iconLoading: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/aulas/total-periodos-diario",
                    params: {
                        cursoId: localStorage.getItem("codigo_curso"),
                        inicio: this.state.inicio,
                        termino: this.state.termino
                    }
                })
                    .then(response => {
                        const { periodos, tooltip } = response.data;

                        this.setState({
                            periodos,
                            periodosTooltip: tooltip !== "" ? tooltip : "Fora do período letivo",
                            iconLoading: false
                        });
                    })
                    .catch(error => {
                        this.setState({
                            iconLoading: false
                        });
                    });
            }
        );
    };

    mostrarPareceres = () => {
        axios({
            method: "get",
            url: "/api/pareceres/mostrar-parecer",
            params: {
                cursoId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                this.setState({ mostrarParecerPorAula: response.data });
            })
            .catch(error => {});
    };

    listar = () => {
        this.setState(
            {
                iconLoading: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/aulas/listar-aulas-horario",
                    params: {
                        cursoId: localStorage.getItem("codigo_curso"),
                        inicio: this.state.inicio,
                        termino: this.state.termino
                    }
                })
                    .then(response => {
                        const aulasOrdenadas = response.data.slice().sort((a, b) => new Date(a.inicio) - new Date(b.inicio));

                        const primeiroRegisto = aulasOrdenadas.shift();
                        const horaPrimeiroRegisto = primeiroRegisto ? new Date(primeiroRegisto.inicio) : null;

                        if (horaPrimeiroRegisto != null) horaPrimeiroRegisto.setHours(horaPrimeiroRegisto.getHours() - 6);

                        const aulas = response.data.map(aula => {
                            return {
                                id: aula.id,
                                title: aula.localizacao?.sala
                                    ? `${aula.localizacao?.sala}${
                                          localStorage.getItem("vista_calendario") === "month"
                                              ? ` ${aula.horaInicio} - ${aula.horaFim}`
                                              : ""
                                      }`
                                    : localStorage.getItem("vista_calendario") === "month"
                                      ? `${aula.horaInicio} - ${aula.horaFim}`
                                      : "",
                                start: new Date(aula.inicio),
                                end: new Date(aula.termino),
                                cor: aula.cor,
                                recorrencia: aula.recorrencia,
                                avaliacao: aula.avaliacao
                            };
                        });

                        this.setState({
                            aulas,
                            horaInicioCalendario: horaPrimeiroRegisto,
                            iconLoading: false
                        });
                    })
                    .catch(error => {
                        if (error.response.status === 401)
                            this.setState({
                                redirect: true,
                                redirectLink: "/login"
                            });

                        this.setState({
                            iconLoading: false
                        });
                    });
            }
        );
    };

    listarFasesEscolares = () => {
        axios({
            method: "get",
            url: "/api/aulas/lista-fases-escolares",
            params: {
                cursoId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                this.setState({
                    fases: response.data
                });
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    listaDiarioEscolaridade = () => {
        axios({
            method: "get",
            url: "/api/aulas/lista-diario-escolaridade",
            params: {
                cursoId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                this.setState({
                    isNota: response.data.isNota,
                    isEJAoF: response.data.categoria,
                    tituloVivencia: response.data.tituloVivencia
                });
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    carregarListaDisciplinas = () => {
        axios({
            method: "get",
            url: "/api/aulas/disciplinas",
            params: {
                id: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                this.setState({
                    listaDisciplinas: response.data
                });
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    onRangeChange = range => {
        if (range.length) {
            this.setState(
                {
                    inicio: moment(range[0]).format("YYYY/MM/DD"),
                    termino: moment(range.pop()).format("YYYY/MM/DD")
                },
                () => {
                    this.listar();
                    this.periodoBimestre();
                }
            );
        } else {
            this.setState(
                {
                    inicio: moment(range.start).format("YYYY/MM/DD"),
                    termino: moment(range.end).format("YYYY/MM/DD")
                },
                () => {
                    this.listar();
                    this.periodoBimestre();
                }
            );
        }
    };

    onDrillDown = range => {
        this.setState(
            {
                inicio: moment(range).format("YYYY/MM/DD"),
                termino: moment(range).format("YYYY/MM/DD"),
                vista: "day",
                dataCalendario: range
            },
            () => {
                localStorage.setItem("posicao_calendario", this.state.dataCalendario);
                localStorage.setItem("vista_calendario", "day");
            }
        );
    };

    onSelectEvent = event => {
        const acesso = this.context.acessos?.find(x => x.func === 17);

        if (acesso?.read) {
            localStorage.setItem("aula_diario", event.id);
            localStorage.setItem("link_voltar_calendario", this.props.match.url);
            localStorage.removeItem("horario_detalhe_titulo");
            this.setState({
                redirect: true,
                redirectLink: `/gerir-detalhe-turma/${this.props.match.params.turma}/horario-detalhe`
            });
        }
    };

    editarEvento = () => {
        this.setState({
            modalEventoVisible: false,
            visible: true
        });
    };

    montarBotaoVoltar = () => {
        if (localStorage.getItem("opcao_voltar") != null) {
            const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));
            return (
                <Link
                    to={opcaoInfo.link_voltar_curso ? opcaoInfo.link_voltar_curso : opcaoInfo.link_voltar}
                    className="botao-secundario botao-secundario-redondo"
                    onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                    style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                    <Icon type="arrow-left" />
                </Link>
            );
        }
    };

    gerarHorario = () => {
        this.setState({
            visibleLoading: true
        });
        if (localStorage.getItem("vista_calendario") === "month")
            axios({
                method: "get",
                url: "/api/pdf/calendario-mes",
                params: {
                    cursoId: localStorage.getItem("codigo_curso"),
                    inicio: this.state.dataCalendario
                }
            })
                .then(response => {
                    const { url, fileName } = response.data;

                    this.setState({
                        docs: [{ uri: url, fileName }],
                        visibleLoading: false,
                        modalVisible: true
                    });
                })
                .catch(() => {
                    openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento!");
                    this.setState({
                        visibleLoading: false
                    });
                });
        else
            axios({
                method: "get",
                url: "/api/pdf/horarios-pp",
                params: {
                    cursoId: localStorage.getItem("codigo_curso"),
                    inicio: this.state.inicio,
                    termino: this.state.termino
                }
            })
                .then(response => {
                    const { url, fileName } = response.data;

                    this.setState({
                        docs: [{ uri: url, fileName }],
                        visibleLoading: false,
                        modalVisible: true
                    });
                })
                .catch(() => {
                    openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento!");
                    this.setState({
                        visibleLoading: false
                    });
                });
    };

    render() {
        const {
            dataCalendario,
            vista,
            aulas,
            horaInicioCalendario,
            dataHoraInicio,
            periodos,
            periodosTooltip,
            isNota,
            isEJAoF,
            tituloVivencia,
            mostrarParecerPorAula,
            //DRAWER ADICIONAR
            visible,
            //REDIRECT
            redirect,
            redirectLink,
            //LOADING
            iconLoading,
            //DOCS
            docs,
            visibleLoading,
            modalVisible,
            empresaId,
            //MODAL CRIAÇÃO LOTE AULAS
            processoId,
            visibleModalCriacaoLoteAulas,
            listaDisciplinas,
            //MODAL PROCESSAR LOTE AULAS
            visibleModalProcessarAulas
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        const eventStyleGetter = (event, start, end, isSelected) => {
            const style = {
                background: event.avaliacao
                    ? `linear-gradient(145deg, rgba(255,166,0,1) 0%, rgba(255,166,0,1) 15%, ${event.cor} 15%)`
                    : event.cor
            };
            return {
                style: style
            };
        };

        const slotPropGetter = date => {
            const rule = blockedRules[date.getDay()];
            const hour = date.getHours();

            // Domingo — tudo bloqueado
            if (!rule) {
                return { className: "rbc-blocked-slot" };
            }

            // Fora do intervalo permitido
            if (hour < rule.start || hour >= rule.end) {
                return { className: "rbc-blocked-slot" };
            }

            return {};
        };

        const toolbar = toolbar => {
            const anterior = () => {
                if (toolbar.view === "month") {
                    toolbar.date.setMonth(toolbar.date.getMonth() - 1);
                    toolbar.onNavigate("prev");
                    this.setState(
                        {
                            dataCalendario: toolbar.date
                        },
                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                    );
                } else if (toolbar.view === "week") {
                    let mDate = this.state.dataCalendario;
                    let newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() - 7);
                    toolbar.onNavigate("prev", newDate);
                    this.setState(
                        {
                            dataCalendario: newDate
                        },
                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                    );
                } else {
                    let mDate = this.state.dataCalendario;
                    let newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() - 1);
                    toolbar.onNavigate("prev", newDate);
                    this.setState(
                        {
                            dataCalendario: newDate
                        },
                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                    );
                }
            };

            const proximo = () => {
                if (toolbar.view === "month") {
                    toolbar.date.setMonth(toolbar.date.getMonth() + 1);
                    toolbar.onNavigate("next");
                    this.setState(
                        {
                            dataCalendario: toolbar.date
                        },
                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                    );
                } else if (toolbar.view === "week") {
                    let mDate = this.state.dataCalendario;
                    let newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() + 7);
                    toolbar.onNavigate("next", newDate);
                    this.setState(
                        {
                            dataCalendario: newDate
                        },
                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                    );
                } else {
                    let mDate = this.state.dataCalendario;
                    let newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() + 1);
                    toolbar.onNavigate("next", newDate);
                    this.setState(
                        {
                            dataCalendario: newDate
                        },
                        () => localStorage.setItem("posicao_calendario", this.state.dataCalendario)
                    );
                }
            };

            const labelData = () => {
                const date = moment(toolbar.date);
                if (toolbar.view === "month") return <span>{date.format("MMMM YYYY")}</span>;
                else if (toolbar.view === "week") {
                    return (
                        <span>
                            {toolbar.label} ({date.format("YYYY")})
                        </span>
                    );
                } else return <span>{date.format("dddd, DD [de] MMMM YYYY")}</span>;
            };

            const vistaMes = () => {
                toolbar.onView("month");
                this.setState(
                    {
                        vista: "month"
                    },
                    () => localStorage.setItem("vista_calendario", "month")
                );
            };

            const vistaSemana = () => {
                toolbar.onView("week");
                this.setState(
                    {
                        vista: "week"
                    },
                    () => localStorage.setItem("vista_calendario", "week")
                );
            };

            const vistaDia = () => {
                toolbar.onView("day");
                this.setState(
                    {
                        vista: "day"
                    },
                    () => localStorage.setItem("vista_calendario", "day")
                );
            };

            const montarTitleSetaEsq = () => {
                if (vista === "month") return "Mês anterior";
                else if (vista === "week") return "Semana anterior";
                else return "Dia anterior";
            };

            const montarTitleSetaDir = () => {
                if (vista === "month") return "Próximo mês";
                else if (vista === "week") return "Próxima semana";
                else return "Próximo dia";
            };

            const disabledDate = current => {
                if (!current) return false;

                const currentYear = new Date().getFullYear();
                const maxYear = currentYear + 1;

                return current.year() < 2000 || current.year() > maxYear;
            };

            return (
                <>
                    <div className="toolbar-container toolbar-container-desktop">
                        <div className="toolbal-opcoes-esquerda" style={{ minWidth: "200px" }}>
                            <Button.Group>
                                <Button className="btn-anterior" title={montarTitleSetaEsq()} onClick={anterior}>
                                    <Icon type="left" />
                                </Button>
                                <Button className="btn-proximo" title={montarTitleSetaDir()} onClick={proximo}>
                                    <Icon type="right" />
                                </Button>
                            </Button.Group>
                        </div>
                        <div className="toolbal-label-data">
                            <Tooltip placement="right" title={periodosTooltip}>
                                <label
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "5px",
                                        cursor: "pointer",
                                        border: "1px solid #d9d9d9",
                                        borderRadius: "4px",
                                        padding: "0px 15px",
                                        boxShadow: "0 2px 0 rgba(0, 0, 0, 0.015)",
                                        marginBottom: 0,
                                        height: "32px",
                                        fontSize: "14px",
                                        fontWeight: "normal"
                                    }}
                                    onClick={this.openMonthPicker}
                                    className="label-data"
                                >
                                    {labelData()} {this.state.monthPickerOpen ? <Icon type="caret-up" /> : <Icon type="caret-down" />}
                                </label>
                            </Tooltip>

                            {vista === "month" && (
                                <MonthPicker
                                    open={this.state.monthPickerOpen}
                                    value={dataCalendario ? moment(dataCalendario) : null}
                                    onOpenChange={open => this.setState({ monthPickerOpen: open })}
                                    onChange={this.handleMonthChange}
                                    style={{
                                        position: "absolute",
                                        opacity: 0,
                                        width: 0,
                                        height: 0,
                                        padding: 0,
                                        margin: 0,
                                        pointerEvents: "none"
                                    }}
                                    disabledDate={disabledDate}
                                    getCalendarContainer={() => document.body}
                                />
                            )}

                            {vista === "week" && (
                                <WeekPicker
                                    open={this.state.monthPickerOpen}
                                    value={dataCalendario ? moment(dataCalendario) : null}
                                    onOpenChange={open => this.setState({ monthPickerOpen: open })}
                                    onChange={this.handleMonthChange}
                                    style={{
                                        position: "absolute",
                                        opacity: 0,
                                        width: 0,
                                        height: 0,
                                        padding: 0,
                                        margin: 0,
                                        pointerEvents: "none"
                                    }}
                                    disabledDate={disabledDate}
                                    getCalendarContainer={() => document.body}
                                />
                            )}
                        </div>
                        <div className="toolbal-opcoes-direita" style={{ minWidth: "200px", textAlign: "right" }}>
                            <Button.Group>
                                <Button className={`btn-mes ${vista === "month" ? " ativa" : ""}`} onClick={vistaMes}>
                                    Mês
                                </Button>
                                <Button className={`btn-semana ${vista === "week" ? " ativa" : ""}`} onClick={vistaSemana}>
                                    Semana
                                </Button>
                            </Button.Group>
                        </div>
                    </div>
                    <div className="toolbar-container toolbar-container-tablet">
                        <div className="toolbal-opcoes-cima">
                            <Button.Group>
                                <Button.Group>
                                    <Button className="btn-anterior" title={montarTitleSetaEsq()} onClick={anterior}>
                                        <Icon type="left" />
                                    </Button>
                                    <Button className="btn-proximo" title={montarTitleSetaDir()} onClick={proximo}>
                                        <Icon type="right" />
                                    </Button>
                                </Button.Group>
                            </Button.Group>
                            <Button.Group>
                                <Button className={`btn-mes ${vista === "month" ? " ativa" : ""}`} onClick={vistaMes}>
                                    Mês
                                </Button>
                                <Button className={`btn-semana ${vista === "week" ? " ativa" : ""}`} onClick={vistaSemana}>
                                    Semana
                                </Button>
                            </Button.Group>
                        </div>
                        <div className="toolbal-opcoes-baixo">
                            <div className="toolbal-label-data">
                                <Tooltip placement="right" title={periodosTooltip}>
                                    <label
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "5px",
                                            cursor: "pointer",
                                            border: "1px solid #d9d9d9",
                                            borderRadius: "4px",
                                            padding: "0px 15px",
                                            boxShadow: "0 2px 0 rgba(0, 0, 0, 0.015)",
                                            marginBottom: 0,
                                            height: "32px",
                                            fontSize: "14px",
                                            fontWeight: "normal"
                                        }}
                                        onClick={this.openMonthPicker}
                                        className="label-data"
                                    >
                                        {labelData()} {this.state.monthPickerOpen ? <Icon type="caret-up" /> : <Icon type="caret-down" />}
                                    </label>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                    <div className="toolbar-container toolbar-container-mobile">
                        <div className="toolbal-opcoes-esquerda">
                            <Button.Group>
                                <Button.Group>
                                    <Button className="btn-anterior" title={montarTitleSetaEsq()} onClick={anterior}>
                                        <Icon type="left" />
                                    </Button>
                                    <Button className="btn-proximo" title={montarTitleSetaDir()} onClick={proximo}>
                                        <Icon type="right" />
                                    </Button>
                                </Button.Group>
                            </Button.Group>
                        </div>
                        <div className="toolbal-opcoes-direita">
                            <Button.Group>
                                <Button className={`btn-mes ${vista === "month" ? " ativa" : ""}`} onClick={vistaMes}>
                                    Mês
                                </Button>
                                <Button className={`btn-dia ${vista === "day" ? " ativa" : ""}`} onClick={vistaDia}>
                                    Dia
                                </Button>
                            </Button.Group>
                        </div>
                        <div className="toolbal-label-data">
                            <Tooltip placement="right" title={periodosTooltip}>
                                <label
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "5px",
                                        cursor: "pointer",
                                        border: "1px solid #d9d9d9",
                                        borderRadius: "4px",
                                        padding: "0px 15px",
                                        boxShadow: "0 2px 0 rgba(0, 0, 0, 0.015)",
                                        marginBottom: 0,
                                        height: "32px",
                                        fontSize: "14px",
                                        fontWeight: "normal"
                                    }}
                                    onClick={this.openMonthPicker}
                                    className="label-data"
                                >
                                    {labelData()} {this.state.monthPickerOpen ? <Icon type="caret-up" /> : <Icon type="caret-down" />}
                                </label>
                            </Tooltip>
                        </div>
                    </div>
                </>
            );
        };

        const hoje = new Date();

        moment.updateLocale("pt", {
            week: {
                dow: 0
            }
        });

        const min = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate(), 5, 0);
        let max = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate(), 19, 0);

        if (localStorage.getItem("header_nivel")?.includes("EJA"))
            max = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate(), 23, 59);

        const acesso = this.context.acessos?.find(x => x.func === 17);

        return (
            <>
                <Acessos funcionalidadeId={17} />
                <div className="container container-body bloco-diario">
                    <div className="turma-visao-geral hidden">
                        <div className="desktop">
                            <div className="controlos controlos-fundo ">
                                <div className="bloco-esquerda">
                                    {acesso?.create && (
                                        <Link
                                            to="#"
                                            className="botao-principal botao-principal-redondo"
                                            title="Nova aula"
                                            onClick={() => this.setState({ visibleModalCriacaoLoteAulas: true })}
                                        >
                                            +
                                        </Link>
                                    )}
                                </div>
                                {localStorage.getItem("entidade_id") === "33" ? (
                                    <div className="bloco-direita">
                                        {isNota && (
                                            <Link
                                                className="botao-icon-relatorio-aproveitamento "
                                                to={`/gerir-detalhe-turma/${this.props.match.params.turma}/relatorios-notas`}
                                                title="Relatórios"
                                                onClick={() => localStorage.removeItem("vista")}
                                            >
                                                <Icon type="table" />
                                                Médias
                                            </Link>
                                        )}
                                        <Link
                                            className="botao-icon-conteudo "
                                            to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-conteudos`}
                                            title="Sumários"
                                            onClick={() => localStorage.removeItem("vista")}
                                        >
                                            <Icon type="read" />
                                            {tituloVivencia ? "Vivências" : "Conteúdos"}
                                        </Link>
                                        <Link
                                            className="botao-icon-frequencia "
                                            to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-frequencia`}
                                            title="Frequência"
                                            onClick={() => localStorage.removeItem("vista")}
                                        >
                                            <Icon type="carry-out" />
                                            Frequências
                                        </Link>
                                        {localStorage.getItem("header_codigo") === "EI" && (
                                            <Link
                                                className="botao-icon-pareceres "
                                                to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-pareceres`}
                                                title="Pareceres"
                                                onClick={() => localStorage.removeItem("vista")}
                                            >
                                                <Icon type="snippets" />
                                                Pareceres
                                            </Link>
                                        )}
                                        <Link
                                            className="botao-icon-observacoes "
                                            to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-observacoes`}
                                            title="Observações"
                                            onClick={() => localStorage.removeItem("vista")}
                                        >
                                            <Icon type="profile" />
                                            Complementares
                                        </Link>
                                        <Link
                                            className="botao-icon-detalhe-diario "
                                            to="#"
                                            title="Descarregar PDF"
                                            onClick={this.gerarHorario}
                                        >
                                            <Icon type="eye" />
                                            Horário
                                        </Link>
                                        {this.montarBotaoVoltar()}
                                    </div>
                                ) : (
                                    <div className="bloco-direita">
                                        <Link
                                            className="botao-icon-conteudo "
                                            to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-conteudos`}
                                            title="Sumários"
                                            onClick={() => localStorage.removeItem("vista")}
                                        >
                                            <Icon type="read" />
                                            {tituloVivencia ? "Vivências" : "Conteúdos"}
                                        </Link>
                                        <Link
                                            className="botao-icon-frequencia "
                                            to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-frequencia`}
                                            title="Frequência"
                                            onClick={() => localStorage.removeItem("vista")}
                                        >
                                            <Icon type="carry-out" />
                                            Frequência
                                        </Link>
                                        {isEJAoF && (
                                            <>
                                                {isNota && (
                                                    <Link
                                                        className="botao-icon-relatorio-aproveitamento "
                                                        to={`/gerir-detalhe-turma/${this.props.match.params.turma}/relatorios-notas`}
                                                        title="Relatórios"
                                                        onClick={() => localStorage.removeItem("vista")}
                                                    >
                                                        <Icon type="table" />
                                                        Resultados
                                                    </Link>
                                                )}
                                                {!isNota && empresaId == 3 && (
                                                    <Link
                                                        className="botao-icon-relatorio-aproveitamento "
                                                        to={`/gerir-detalhe-turma/${this.props.match.params.turma}/relatorios-apc`}
                                                        title="Relatórios"
                                                        onClick={() => localStorage.removeItem("vista")}
                                                    >
                                                        <Icon type="table" />
                                                        Resultados
                                                    </Link>
                                                )}
                                            </>
                                        )}
                                        {mostrarParecerPorAula && (
                                            <Link
                                                className="botao-icon-pareceres "
                                                to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-pareceres`}
                                                title="Pareceres"
                                                onClick={() => localStorage.removeItem("vista")}
                                            >
                                                <Icon type="snippets" />
                                                Pareceres
                                            </Link>
                                        )}
                                        <Link
                                            className="botao-icon-observacoes "
                                            to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-observacoes`}
                                            title="Observações"
                                            onClick={() => localStorage.removeItem("vista")}
                                        >
                                            <Icon type="profile" />
                                            Observações
                                        </Link>
                                        <Link
                                            className="botao-icon-detalhe-diario "
                                            to="#"
                                            title="Descarregar PDF"
                                            onClick={this.gerarHorario}
                                        >
                                            <Icon type="eye" />
                                            Horário
                                        </Link>
                                        {this.montarBotaoVoltar()}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="mobile">
                            <div className="controlos controlos-fundo ">
                                <div className="bloco-esquerda" style={{ justifyContent: "space-between" }}>
                                    {acesso?.create && (
                                        <Link
                                            to="#"
                                            className="botao-principal botao-principal-redondo"
                                            title="Nova aula"
                                            onClick={() => this.setState({ visibleModalCriacaoLoteAulas: true })}
                                        >
                                            +
                                        </Link>
                                    )}
                                    {this.montarBotaoVoltar()}
                                </div>
                                {localStorage.getItem("entidade_id") === "33" ? (
                                    <div className="bloco-direita">
                                        {isNota && (
                                            <Link
                                                className="botao-icon-relatorio-aproveitamento "
                                                to={`/gerir-detalhe-turma/${this.props.match.params.turma}/relatorios-notas`}
                                                title="Relatórios"
                                                onClick={() => localStorage.removeItem("vista")}
                                            >
                                                <Icon type="table" />
                                                Médias
                                            </Link>
                                        )}
                                        <Link
                                            className="botao-icon-conteudo "
                                            to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-conteudos`}
                                            title="Sumários"
                                            onClick={() => localStorage.removeItem("vista")}
                                        >
                                            <Icon type="read" />
                                            {tituloVivencia ? "Vivências" : "Conteúdos"}
                                        </Link>
                                        <Link
                                            className="botao-icon-frequencia "
                                            to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-frequencia`}
                                            title="Frequência"
                                            onClick={() => localStorage.removeItem("vista")}
                                        >
                                            <Icon type="carry-out" />
                                            Frequências
                                        </Link>
                                        {localStorage.getItem("header_codigo") === "EI" && (
                                            <Link
                                                className="botao-icon-pareceres "
                                                to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-pareceres`}
                                                title="Pareceres"
                                                onClick={() => localStorage.removeItem("vista")}
                                            >
                                                <Icon type="snippets" />
                                                Pareceres
                                            </Link>
                                        )}
                                        <Link
                                            className="botao-icon-observacoes "
                                            to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-observacoes`}
                                            title="Observações"
                                            onClick={() => localStorage.removeItem("vista")}
                                        >
                                            <Icon type="profile" />
                                            Complementares
                                        </Link>
                                        <Link
                                            className="botao-icon-detalhe-diario "
                                            to="#"
                                            title="Descarregar PDF"
                                            onClick={this.gerarHorario}
                                        >
                                            <Icon type="eye" />
                                            Horário
                                        </Link>
                                        {/*{this.montarBotaoVoltar()}*/}
                                    </div>
                                ) : (
                                    <div className="bloco-direita">
                                        <Link
                                            className="botao-icon-conteudo "
                                            to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-conteudos`}
                                            title="Sumários"
                                            onClick={() => localStorage.removeItem("vista")}
                                        >
                                            <Icon type="read" />
                                            {tituloVivencia ? "Vivências" : "Conteúdos"}
                                        </Link>
                                        <Link
                                            className="botao-icon-frequencia "
                                            to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-frequencia`}
                                            title="Frequência"
                                            onClick={() => localStorage.removeItem("vista")}
                                        >
                                            <Icon type="carry-out" />
                                            Frequência
                                        </Link>
                                        {isEJAoF && (
                                            <>
                                                {isNota && (
                                                    <Link
                                                        className="botao-icon-relatorio-aproveitamento "
                                                        to={`/gerir-detalhe-turma/${this.props.match.params.turma}/relatorios-notas`}
                                                        title="Relatórios"
                                                        onClick={() => localStorage.removeItem("vista")}
                                                    >
                                                        <Icon type="table" />
                                                        Resultados
                                                    </Link>
                                                )}
                                                {!isNota && empresaId == 3 && (
                                                    <Link
                                                        className="botao-icon-relatorio-aproveitamento "
                                                        to={`/gerir-detalhe-turma/${this.props.match.params.turma}/relatorios-apc`}
                                                        title="Relatórios"
                                                        onClick={() => localStorage.removeItem("vista")}
                                                    >
                                                        <Icon type="table" />
                                                        Resultados
                                                    </Link>
                                                )}
                                            </>
                                        )}
                                        {mostrarParecerPorAula && (
                                            <Link
                                                className="botao-icon-pareceres "
                                                to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-pareceres`}
                                                title="Pareceres"
                                                onClick={() => localStorage.removeItem("vista")}
                                            >
                                                <Icon type="snippets" />
                                                Pareceres
                                            </Link>
                                        )}
                                        <Link
                                            className="botao-icon-observacoes "
                                            to={`/gerir-detalhe-turma/${this.props.match.params.turma}/diario-folha-observacoes`}
                                            title="Observações"
                                            onClick={() => localStorage.removeItem("vista")}
                                        >
                                            <Icon type="profile" />
                                            Observações
                                        </Link>
                                        <Link
                                            className="botao-icon-detalhe-diario "
                                            to="#"
                                            title="Descarregar PDF"
                                            onClick={this.gerarHorario}
                                        >
                                            <Icon type="eye" />
                                            Horário
                                        </Link>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="curso-diario">
                        <Calendar
                            localizer={localizer}
                            events={aulas}
                            min={min}
                            max={max}
                            scrollToTime={
                                new Date(
                                    hoje.getFullYear(),
                                    hoje.getMonth(),
                                    hoje.getDate(),
                                    horaInicioCalendario?.getHours(),
                                    horaInicioCalendario?.getMinutes()
                                )
                            }
                            startAccessor="start"
                            endAccessor="end"
                            style={{ height: 700 }}
                            defaultView={vista}
                            view={vista}
                            date={dataCalendario}
                            views={["month", "week", "day"]}
                            components={{
                                toolbar: toolbar
                            }}
                            onView={() => {}}
                            onNavigate={() => {}}
                            onSelectEvent={this.onSelectEvent}
                            onDrillDown={this.onDrillDown}
                            onRangeChange={this.onRangeChange}
                            eventPropGetter={eventStyleGetter}
                            selectable={true}
                            onSelecting={() => false}
                            onSelectSlot={this.handleSelectSlot}
                            slotPropGetter={slotPropGetter}
                        />
                        <Legenda />
                    </div>
                </div>
                <DrawerAdicionarAula
                    disciplinaId={localStorage.getItem("codigo_curso")}
                    filtroEscolaId={this.state.filtroEscolaId}
                    visible={visible}
                    onClose={() =>
                        this.setState({
                            visible: false
                        })
                    }
                    dataHoraInicio={dataHoraInicio}
                    adicionarAula={evento => this.setState({ aulas: [...aulas, evento], visible: false })}
                    adicionarAulas={evento => this.setState({ aulas: [...aulas, evento], visible: false })}
                    atualizarPosicaoCalendário={dataCalendario => this.atualizarPosicaoCalendário(dataCalendario)}
                    atualizarListagem={() => {
                        this.setState({ visible: false });
                        this.listar();
                        this.periodoBimestre();
                    }}
                />
                <Modal visible={iconLoading} maskClosable={false} className="modal-loading" footer={null} closable={false}>
                    <div className="modal-loading-bloco">
                        <p>
                            <Icon type="loading" />
                        </p>
                        <p className="texto">A carregar...</p>
                    </div>
                </Modal>
                <ModalLoading visible={visibleLoading} text="A gerar documento..." />
                <ModalViewer visible={modalVisible} docs={docs} onCancel={() => this.setState({ modalVisible: false })} />
                <ModalCriacaoLoteAulas
                    visible={visibleModalCriacaoLoteAulas}
                    disciplinas={listaDisciplinas}
                    dataCalendario={dataCalendario}
                    vistaCalendario={vista}
                    onSalvar={() => {
                        this.setState({ visibleModalCriacaoLoteAulas: false });
                        this.listar();
                        this.periodoBimestre();
                    }}
                    onSalvarRepetir={processoId => {
                        this.setState({ processoId, visibleModalCriacaoLoteAulas: false, visibleModalProcessarAulas: true });
                        this.listar();
                        this.periodoBimestre();
                    }}
                    onClose={() => this.setState({ visibleModalCriacaoLoteAulas: false })}
                />
                <ModalProcessarAulas
                    processoId={processoId}
                    visible={visibleModalProcessarAulas}
                    onClose={() => {
                        this.setState({ visibleModalProcessarAulas: false });
                        this.listar();
                        this.periodoBimestre();
                    }}
                />
            </>
        );
    }
}

const ContextMain = ({ match }) => (
    <GlobalContext.Consumer>{({ estabelecimento }) => <Main estabelecimento={estabelecimento} match={match} />}</GlobalContext.Consumer>
);

export default ContextMain;
